<template>
  <div>
    <v-card
      :outlined="outlined"
      tile
      elevation="0"
    >
      <v-tabs
        v-model="index"
        centered
        @change="loadComponentData"
      >
        <v-tab
          v-if="menus[0] === 0"
          :key="0"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            توصي
          </template>
          <template v-else>
            Recommends
          </template>
        </v-tab>
        <v-divider
          v-if="menus[1] === 1"
          class="mx-4 align-self-center"
          vertical
          style="border-width:1px;border-color:#666;min-height:35%"
        />
        <v-tab
          v-if="menus[1] === 1"
          :key="1"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            منتج جديد
          </template>
          <template v-else>
            New Arrivals
          </template>
        </v-tab>
        <v-divider
          v-if="menus[2] === 2"
          class="mx-4 align-self-center"
          vertical
          style="border-width:1px;border-color:#666;min-height:35%"
        />
        <v-tab
          v-if="menus[2] === 2"
          :key="2"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            الأفضل مبيعًا
          </template>
          <template v-else>
            Best sellers
          </template>
        </v-tab>
      </v-tabs>
      <v-divider v-if="outlined" />
      <v-container>
        <v-row
          v-if="loading"
          class="text-center"
        >
          <v-col
            v-for="i in 12"
            :key="i"
            :cols="$store.state.mobile ? 6 : 2"
          >
            <div class="px-4">
              <v-skeleton-loader
                type="image"
              />
            </div>
            <v-skeleton-loader
              type="list-item-two-line"
            />
          </v-col>
        </v-row>
        <v-row v-else-if="localGoods.length">
          <v-col
            v-for="item in localGoods"
            :key="item.id"
            :cols="$store.state.mobile ? 6 : 2"
          >
            <div :class="$store.state.mobile ? '' : 'py-3'">
              <v-card
                outlined
                tile
                :to="{name: 'GoodsDetail', params: {id: item.id}}"
              >
                <v-img
                  aspect-ratio="1"
                  contain
                  :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
                  color="grey lighten-5"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey"
                      />
                    </v-row>
                  </template>
                </v-img>
              </v-card>
              <div class="px-4 text-center">
                <div class="text-h6  mt-2 text-truncate">
                  <router-link
                    :to="{name: 'GoodsDetail', params: {id: item.id}}"
                  >
                    {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                  </router-link>
                </div>
                <div
                  v-if="$store.state.usedCountry"
                  class="text-h6 font-medium d-flex align-center justify-center"
                >
                  <span
                    class="text-h4 me-2"
                  >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                  <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <div
          v-else
          class="grey--text text-center py-4"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            لا يوجد شيء هنا
          </template>
          <template v-else>
            There is nothing here
          </template>
        </div>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'TabGoods',
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
    menus: {
      type: Array,
      default: () => [0, 1, 2],
    },
  },
  data() {
    return {
      index: 0,
      loading: false,
      tabs: [
        {
          index: 0,
          type: '4',
          title: 'توصي',
          titleEn: 'Recommends',
          target: 'recommends',
        },
        {
          index: 1,
          type: '2',
          title: 'القادمون الجدد',
          titleEn: 'New Arrivals',
          target: 'newArrivals',
        },
        {
          index: 2,
          type: '3',
          title: 'أفضل البائعين',
          titleEn: 'Best Sellers',
          target: 'bestSellers',
        },
      ],
    };
  },
  computed: {
    ...mapState(['tagGoods']),
    ...mapGetters(['tagGoodsGetter']),
    localGoods() {
      return this.tagGoodsGetter(this.tabs[this.index].target, 12);
    },
    // tabsLocal() {
    //   return this.menus.map((index) => this.tabs[index]);
    // },
  },
  created() {
    this.loadComponentData();
  },
  methods: {
    ...mapActions(['getGoodsByTagAsync']),
    loadComponentData() {
      const p = this.tagGoods[this.tabs[this.index].target].currentPage;
      if (+p > 1) {
        this.$store.commit('RESET_TAG_GOODS');
      }
      this.loading = true;
      this.getGoodsByTagAsync({
        type: this.tabs[this.index].type, p: 1, name: this.tabs[this.index].target,
      }).finally(() => {
        this.loading = false;
      });
    },
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
